module.exports = __webpack_public_path__ + "img/icon_my_female.ed7f185c.png";